import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Sos carpintero, instalador o dueño de taller de aberturas PVC', 'Querés dejar de calcular descuentos de cabeza', 'Tenés ayudante y querés que trabaje sin preguntarte todo', 'Querés presupuestar con margen real', 'Perdiste plata alguna vez por un cristal mal medido'];
const noItems = ['Buscás teoría sin aplicación práctica', 'Creés que ya lo sabés todo'];
export function IsForYou() {
  return <section className="py-16 bg-bg border-t border-white/5" aria-label="¿Es para vos?" data-id="element-165">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-166">
        <FadeIn data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10" data-id="element-168">
            ¿ESTE SISTEMA ES PARA <span className="text-gold" data-id="element-169">VOS</span>?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-170">
          <FadeIn delay={0.1} data-id="element-171">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-emerald-500/20 h-full" data-id="element-172">
              <div className="flex items-center gap-3 mb-6" data-id="element-173">
                <span className="text-2xl" data-id="element-174">✅</span>
                <h3 className="text-xl font-heading font-bold text-emerald-400" data-id="element-175">
                  Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-176">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-177">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-178" />
                    <span className="text-gray-200" data-id="element-179">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-180">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-red-500/20 h-full" data-id="element-181">
              <div className="flex items-center gap-3 mb-6" data-id="element-182">
                <span className="text-2xl" data-id="element-183">❌</span>
                <h3 className="text-xl font-heading font-bold text-red-400" data-id="element-184">
                  No es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-185">
                {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-186">
                    <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-187" />
                    <span className="text-gray-300" data-id="element-188">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}